module.exports = __webpack_public_path__ + "footer-background.f4ea0a0dc09005c33ae6.png";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/assets/images/template/footer-background.png
// module id = ../../../../../src/assets/images/template/footer-background.png
// module chunks = styles